import { render, staticRenderFns } from "./Loginpage.vue?vue&type=template&id=c5a5e776&scoped=true"
import script from "./Loginpage.vue?vue&type=script&lang=js"
export * from "./Loginpage.vue?vue&type=script&lang=js"
import style0 from "./Loginpage.vue?vue&type=style&index=0&id=c5a5e776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a5e776",
  null
  
)

export default component.exports